import React from "react";
import "./Footer.css";



const Footer = () => {
  return (
    <div>
      <div className="footer-container">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="left-container text-start">
                <h1>Special Child Educacion</h1>
                <div className="icons-container d-flex text-center ">
                  <div className="icon">

                  </div>
                  <div className="icon">

                  </div>
                  <div className="icon">

                  </div>
                  <div className="icon">

                  </div>
                </div>
                <p className="mt-4 ">
                  <small>
                    *FOSTERING AN ENVIRONMENT OF INCLUSION FOR PEOPLE WITH INTELLECTUAL DISABILITIES ON THE NORTH SHORE FOR 0 YEARS.
                  </small>
                </p>

                <p className="mt-5">
                  <small>Tuhin © . All rights reserved.</small>
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="footer-menu-container">
                <ul>
                  <li className="footer-menu">Home</li>
                  <li className="footer-menu">Services</li>
                  <li className="footer-menu">Sports</li>
                  <li className="footer-menu">Contact us</li>
                  <li className="footer-menu"> About us</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="right-footer-container">
                <h3>Sign up for the newsletter</h3>
                <input
                  className="footer-input"
                  type="text"
                  placeholder="Enter Email"
                />
                <div className="phone d-flex align-items-center justify-content-center mt-4">
                  <div className="foter-phone-icon">

                  </div>
                  <div>
                    <h5>+1 8 800 555 35 35</h5>
                  </div>
                </div>
                <div className="map d-flex align-items-center justify-content-center">
                  <div className="foter-phone-icon">

                  </div>
                  <div>
                    <p>
                      160 Collage Road, Dhaka, CD 10035
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
